<template>
  <div class="box-bg">
    <div class="loginBg" :style="loginBg">
      <!-- <el-image :src="logoUrl" /> -->
      <div class="logo" :style="logoUrl" />
    </div>
    <div class="login-container">
      <div class="login-form">
        <div class="title-container">
          <h3 class="title">{{ $t('login.title') }} <span class="title_span">{{ $t('route.routeItp') }}</span></h3>
          <!-- <lang-select class="set-language" /> -->
        </div>
        <el-form
          ref="loginForm"
          :model="loginForm"
          :rules="loginRules"
          autocomplete="on"
          label-position="left"
        >
          <p>{{ $t('login.username') }}</p>
          <el-form-item prop="username" class="user-input">
            <el-input
              ref="username"
              v-model="loginForm.username"
              name="username"
              type="text"
              tabindex="1"
              autocomplete="on"
            />
          </el-form-item>
          <p>{{ $t('login.password') }}</p>
          <el-tooltip
            v-model="capsTooltip"
            content="Caps lock is On"
            placement="right"
            manual
          >
            <el-form-item prop="password" class="password-input">
              <el-input
                :key="passwordType"
                ref="password"
                v-model="loginForm.password"
                :type="passwordType"
                name="password"
                tabindex="2"
                autocomplete="on"
                @keyup.native="checkCapslock"
                @blur="capsTooltip = false"
                @keyup.enter.native="handleLogin"
              />
              <span class="show-pwd" @click="showPwd" />
            </el-form-item>
          </el-tooltip>
          <!-- <div class="forget">忘记密码</div> -->
          <el-row>
            <el-button
              type="primary"
              class="login"
              @click.native.prevent="handleLogin"
            >
              {{ $t('login.logIn') }}
            </el-button>
            <el-link :underline="false" class="loginInAd" @click="getLoginAD"><svg-icon icon-class="frame58" class="iconClass" />销服账号登录</el-link>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { validUsername } from '@/utils/validate'

import getCodeApi from '@/api/sso/getCode-api'
export default {
  name: 'AdLogin',
  // components: { LangSelect },
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'))
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
        // console.log(reg.test(value))
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号'))
        }
      }
    }
    var verCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入6位验证码'))
      } else {
        const reg = /^\d{6}$/
        // console.log(reg.test(value))
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的验证码'))
        }
      }
    }
    const validateUsername = (rule, value, callback) => {
      if (!validUsername(value)) {
        callback(new Error('Please enter the correct user name'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length < 5) {
        callback(new Error('The password can not be less than 5 digits'))
      } else {
        callback()
      }
    }
    return {
      activeName: 'first',
      loginForm: {
        username: '',
        password: ''
      },
      loginFormMobile: {
         mobile: '',
         verifyCode: ''
      },
      loginRules: {
        username: [
          { required: true, trigger: 'blur', validator: validateUsername }
        ],
        password: [
          { required: true, trigger: 'blur', validator: validatePassword }
        ]
      },
      loginRulesMobile: {
         mobile: [{ validator: checkPhone, trigger: 'blur' }],
         verifyCode: [{ validator: verCode, trigger: 'blur' }]
      },
        loginBg: {
        backgroundImage: 'url(' + require('../../assets/images/loginBg.png') + ')',
        backgroundRepeat: 'no-repeat'
      },
      passwordType: 'password',
      capsTooltip: false,
      loading: false,
      showDialog: false,
      disabled: false,
      usernameBlock: false,
      redirect: undefined,
      usernameLogin: '',
      count: null,
      timer: null,
      showBlock: false,
      userNameOptions: [],
      otherQuery: {},
      baseURL: process.env.VUE_APP_BASE_URL,
      logoUrl: {
        backgroundImage: 'url(' + require('../../assets/images/login-logo.png') + ')'
      }
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        const query = this.$route.query
        const getQueryString = (name, search) => {
        search = search || window.location.search.substr(1) || window.location.hash.split("?")[1];
        const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        if (search) {
            const r = search.match(reg);
            if (r != null) return unescape(r[2]); return null;
          } else {
            return
          }
        }
        const queryCode = getQueryString('code')
        if (queryCode === undefined) {
          /* has no code */
          // redirect server url to delete illegal cookie (special for leap-motor project)
          window.location.href = process.env.VUE_APP_BASE_API + "/sso/delSpecCookie";
        } else if (queryCode) {
          /* has code */
          console.log(this.$route.query.code)
          this.loading = true
          this.$store
            .dispatch('user/ssologin', queryCode)
            .then(res => {
              this.$router.push({
                path: this.redirect || '/',
                query: this.otherQuery
              })
              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
          if (query) {
            this.redirect = query.redirect
            this.otherQuery = this.getOtherQuery(query)
          }
        }
      },
      immediate: true
    }
  },
  created() {
    // window.addEventListener('storage', this.afterQRScan)
  },
  mounted() {
    if (this.loginForm.username === '') {
      this.$refs.username.focus()
    } else if (this.loginForm.password === '') {
      this.$refs.password.focus()
    }
  },
  destroyed() {
    // window.removeEventListener('storage', this.afterQRScan)
  },
  methods: {
    checkCapslock(e) {
      const { key } = e
      this.capsTooltip = key && key.length === 1 && key >= 'A' && key <= 'Z'
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    getLoginAD() {
       window.location.href = this.baseURL
    },
    reset() {
      // alert('重置密码')
      this.loginForm.password = ''
      this.loginFormMobile.mobile = ''
      this.loginFormMobile.verifyCode = ''
    },
    // 获取短信验证码
    getCode() {
      console.log(this.loginFormMobile.mobile);
      this.$refs.loginFormMobile.validateField('mobile', (mobileError) => {
        if (!mobileError) {
              getCodeApi.validateLogin(this.loginFormMobile.mobile).then(response => {
             // axios请求
            // 验证码倒计时
              this.usernameBlock = true;
              this.userNameOptions = response.data
            if (!this.timer) {
              this.count = 60;
              this.show = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= 60) {
                  this.count--;
                  this.disabled = true;
                  this.showBlock = true
                } else {
                  this.showBlock = false;
                  clearInterval(this.timer);
                  this.timer = null;
                  this.disabled = false
                }
              }, 1000);
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    // SSO登录
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store
            .dispatch('user/login', this.loginForm)
            .then(res => {
              this.$router.push({
                path: this.redirect || '/',
                query: this.otherQuery
              })
              this.loading = false
              const { loginSysUserVo } = res
              localStorage.setItem('userId', loginSysUserVo.id)
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur]
        }
        return acc
      }, {})
    }
    // afterQRScan() {
    //   if (e.key === 'x-admin-oauth-code') {
    //     const code = getQueryObject(e.newValue)
    //     const codeMap = {
    //       wechat: 'code',
    //       tencent: 'code'
    //     }
    //     const type = codeMap[this.auth_type]
    //     const codeName = code[type]
    //     if (codeName) {
    //       this.$store.dispatch('LoginByThirdparty', codeName).then(() => {
    //         this.$router.push({ path: this.redirect || '/' })
    //       })
    //     } else {
    //       alert('第三方登录失败')
    //     }
    //   }
    // }
  }
}
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #283443;
$light_gray: #fff;
$cursor: #ccc;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}

/* reset element-ui css */
.login-container {
  .el-dropdown{
    position: absolute;
    top: 2px;
    right: 0px;
  }
  .el-input {
    display: inline-block;
    height: 24px;
    width: 100%;

    input {
      border: 0px;
      border-radius: 0px;
      color: #888;
      height: 26px;
    }
  }

  .el-form-item {
    border-radius: 5px;
    color: #888;
  }
}
</style>

<style lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;

.box-bg {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  position: relative;
  .loginBg{
    float: left;
    width: 46%;
    height: 100%;
    background-position:center center;

  }
  .logo {
    position: absolute;
    top: 5%;
    left: 5%;
    width: 222px;
    height: 45px;
    background-position: center;
  }

  .login-container {
    width: 100%;
    // background: $bg;

    overflow: hidden;

    .login-form {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 17%;
      width: 380px;
      max-width: 100%;
      height: 370px;
      border-radius: 5px;
      padding: 40px;
      background-size: cover;
      background-position: center;
      box-shadow: 0 0 8px 1px #e7e8e8;
       .title-container {
          position: absolute;
          top: -47px;
          left: 0px;

          .title {
            font-size: 18px;
            color: #000;
            margin: 0px auto 20px auto;
            text-align: left;
            padding-bottom: 8px;
            font-weight: 400;
            .title_span{
              font-size: 12px;
              color: #888;
              padding-left: 10px;
            }
          }
        }
        .loginInAd{
          padding: 20px 0;
          text-align: center;
          margin: 0 auto;
          display: inline-block;
          width: 100%;
          font-weight: bold;
          .iconClass{
            font-size: 14px;
            margin-right: 5px;
          }
        }
        p{
          margin: 8px 4px;
          font-size: 14px;
        }
      .verificatCode {
        font-size: 10px;
        cursor: pointer;
        color: #1890ff;
        margin-bottom: 10px;
        margin-top: -10px;
        display: inline-block;
        text-align: right;
      }
      .count{
        margin-left: 5px;
      }
      .userSelect{
        margin-left: 10px;
        width: 140px;
        border: 1px solid #ccc;
        height: 26px;
        line-height: 24px;
        border-radius: 5px;
        .el-input input{
         height: 24px !important;
        }
      }
    }
    .forget {
      text-align: center;
      font-size: 12px;
      color: #999;
      margin: 20px 0;
    }
    .reset,
    .login {
      width: 100%;
      height: 38px;
    }
    .login {
      background-color: #1890ff;
    }
    .reset {
      border: 1px solid #69a9c5;
      color: #bbb;
      box-shadow: 1px 0px 1px 1px #c5ffff;
    }
    .tips {
      font-size: 14px;
      color: #fff;
      margin-bottom: 10px;

      span {
        &:first-of-type {
          margin-right: 16px;
        }
      }
    }

    .svg-container {
      padding: 1px 5px 6px 15px;
      color: $dark_gray;
      vertical-align: middle;
      width: 30px;
      display: inline-block;
    }

    .show-pwd {
      position: absolute;
      right: 10px;
      top: 7px;
      font-size: 16px;
      color: $dark_gray;
      cursor: pointer;
      user-select: none;
    }

    .thirdparty-button {
      position: absolute;
      right: 0;
      bottom: 6px;
    }
  }
}
@media only screen and (max-width: 470px) {
  .thirdparty-button {
    display: none;
  }
}
</style>
